import { render, staticRenderFns } from "./newsRequired.vue?vue&type=template&id=154a1eb9"
import script from "./newsRequired.vue?vue&type=script&lang=js"
export * from "./newsRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports